/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const flow_chain_about = () => `<p>Flow is a layer one blockchain designed from the ground up for consumer apps and the digital assets that power them. The network runs on a Proof of Stake consensus mechanism with a unique &quot;multi-role&quot; architecture that solves the blockchain trilemma, balancing scalability, efficiency, and cost.<p>FLOW ($FLOW) is the native utility token that is used for:<ul><li>Fees for processing transactions and storing data.<li>Buying, selling, and trading assets on Flow<li>Staking and delegating to secure the network</ul><p>Flow tools include:<ul><li>Cadence, a purpose-built smart contract programming language designed for consumer-grade applications<li>Full EVM equivalence, allowing anything from Ethereum to work on Flow<li>Protocol-level account abstraction and mobile support for onboarding new users<li>Cross-chain interoperability with the wider web3 ecosystem<li>Developer hub with comprehensive documentation and tools</ul>`
